import { useQuery } from "@apollo/client";
import { NewFieldStyles, SelectFieldOption_Values } from "../../Definitions";
import { useUser } from "../../Services";
import { DomainLanControllersResponse, GET_LAN_CONTROLLERS_BY_DOMAIN } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLanControllersByDomain";
import { NewSelect } from "../BaseComponents";
import { useAicoConnection } from "./aicoConnectionContext";
import { LoadingSpinner } from "../../Services/wrapper";

export interface AicoConnectionProps {
	hideLANControllers?: boolean
}

export default function AicoConnection({hideLANControllers}: AicoConnectionProps) {
	const { userFarms } = useUser();
	const { state, setDomain, setLanControllerId } = useAicoConnection();

	const { data: lanControllers, loading, error } = useQuery<DomainLanControllersResponse>(GET_LAN_CONTROLLERS_BY_DOMAIN, { //TODO(MTH): handle fetching more lan controllers
		variables: { domain: state.domain, limit: 500, offset: 0 },
		skip: !state.domain	
	});

	function handleDomainChange(value: SelectFieldOption_Values | undefined) {
		setDomain(value?.value ?? null);
	}

	function handleLanControllerChange(value: SelectFieldOption_Values | undefined) {
		if (!value?.value) {
			return;
		}

		const lanControllerId = parseInt(value?.value);

		if (isNaN(lanControllerId)) {
			return;
		}

		setLanControllerId(lanControllerId);
	}

	function getLCSelectState() {
		const lc = lanControllers?.controller.lanControllers.find(e => e.lan_controller_id === state.lanControllerId);
		if (!lc) {
			return undefined;
		}

		return {
			label: String(lc.lan_controller_id) + " | " + lc.cpu_id, 
			value: String(lc.lan_controller_id),
			id: lc.lan_controller_id
		}
	}

	return (
		<div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
			<NewSelect
				placeholder="Domain"
				fieldOverrides={{ fieldStyle: NewFieldStyles.greyDarkPrimary }}
				options={userFarms?.map(farm => ({label: farm.domain, value: farm.domain})) ?? []}
				isClearable
				isSearchable
				onChange={handleDomainChange}
				valueOverrides={{defaultValue: state.domain ? { label: state.domain, value:state.domain, id: state.domain } : undefined}}
			/>

			{!hideLANControllers &&
			<>
			{loading && <LoadingSpinner/>}
			{error && <div style={{ color: "#aa0000", backgroundColor: "white" }}>ERROR fetching LAN Controllers</div>}
			{!loading && !error && lanControllers?.controller.lanControllers &&
				<NewSelect
					options={lanControllers?.controller.lanControllers.map(lc => ({label: String(lc.lan_controller_id) + " | " + lc.cpu_id, value: String(lc.lan_controller_id)})) ?? []}
					isClearable
					isSearchable
					placeholder="Lan Controllers"
					fieldOverrides={{ fieldStyle: NewFieldStyles.greyDarkPrimary }}
					onChange={handleLanControllerChange}
					valueOverrides={{defaultValue: getLCSelectState()}}
				/>
			}
			</>
			}
		</div>
	);
}
